import React from "react";
import { Modal } from "react-bootstrap";
export default class PageDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.pageSettings,
    };
  }
  onHide = () => {
    this.props.onHide();
  };
  onSave = () => {
    this.props.onSave(this.state.data);
  };
  onChange = (e) => {
    let id = e.target.id;
    let type = e.target.getAttribute("type");
    let value = type === "checkbox" ? e.target.checked : e.target.value;

    let data = this.state.data;

    data[id] = value;
    this.setState({ data });
  };

  render() {
    return (
      <>
        <Modal show onHide={this.onHide}>
          <Modal.Header closeButton closeLabel="Закрыть">
            <Modal.Title>Параметры страницы</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="form-gourp">
              <label>Ориентация страницы</label>
              <select
                id="orientation"
                className="form-control"
                value={this.state.data.orientation}
                onChange={this.onChange}
              >
                <option value="portrait">Книжная</option>
                <option value="landscape">Альбомная</option>
              </select>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button title="Сохранить параметры страницы" onClick={this.onSave} className="btn btn-primary">
              Сохранить
            </button>
            <button title="Закрыть без сохранения" onClick={this.onHide} className="btn btn-light">
              Отмена
            </button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}
